import { useLocalization } from "@fluent/react";
import { useFeature } from "byzantine";
import BaseBanner from "../BaseBanner";
import { QuickActionsBarContainer } from "../quick_actions";
import { useCurrentUser } from "../contexts/CurrentUserContext";

const DashboardHeader = () => {
  const { l10n } = useLocalization();
  const { features } = useFeature();
  const { currentUser } = useCurrentUser();
  const userName =
    currentUser?.org_name || currentUser?.getShortDescription() || "";
  return (
    <>
      <BaseBanner
        bannerName={l10n.getString("dashboard-welcome", { userName })}
        buttonFunction={() => window.location.assign("/transfer/")}
        buttonName={l10n.getString("button-transfer", null, "Transfer funds")}
        orFeatureFlagChecks={["transfers"]}
        features={features}
      />
      <QuickActionsBarContainer />
    </>
  );
};

export default DashboardHeader;
